define('controllers/favorites',['require','chaplin','controllers/base/controller','models/pages/favorites/index','views/pages/favorites/index','models/pages/favorites/providerItem','models/pages/favorites/goodsItem'],function(require) {
    'use strict';

    var Chaplin = require('chaplin'),
        Controller = require('controllers/base/controller'),
        FavoritesPageModel = require('models/pages/favorites/index'),
        FavoritesPageView = require('views/pages/favorites/index'),

        FavoriteProviderItemModel = require('models/pages/favorites/providerItem'),
        FavoriteGoodsItemModel = require('models/pages/favorites/goodsItem');


    var FavoritesController = Controller.extend({
        show: function(params) {
            var model = new FavoritesPageModel({
                page: params.page,
                favFilter: params.favFilter
            });

            var pageView = new FavoritesPageView({model: model});

            this.view = pageView;
        }
    });


    Chaplin.mediator.setHandler('addFavoriteSeller', function(sellerId) {
        var model = new FavoriteProviderItemModel({ sellerId: sellerId });
        return model.save()
            .then(function() {
                Chaplin.mediator.publish('addFavoriteSeller', model.getAttributes());
            });
    });

    Chaplin.mediator.setHandler('removeFavoriteSeller', function(favoriteId) {
        var data = { id: favoriteId };
        var model = new FavoriteProviderItemModel(data);
        return model.destroy()
            .then(function() {
                Chaplin.mediator.publish('removeFavoriteSeller', data);
            });
    });

    Chaplin.mediator.setHandler('addFavoriteGoods', function(goodsId) {
        var model = new FavoriteGoodsItemModel({ goodsId: goodsId });
        return model.save()
            .then(function() {
                Chaplin.mediator.publish('addFavoriteGoods', model.getAttributes());
            });
    });

    Chaplin.mediator.setHandler('removeFavoriteGoods', function(favoriteId) {
        var data = { id: favoriteId };
        var model = new FavoriteGoodsItemModel(data);
        return model.destroy()
            .then(function() {
                Chaplin.mediator.publish('removeFavoriteGoods', data);
            });
    });

    return FavoritesController;
});
